// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__oerMC","red":"Label_red__WmhIX","orange":"Label_orange__fGEvs"};